import styled, { keyframes } from "styled-components";

const appearFromLeft = keyframes`
  from { opacity: 0; transform: translateX(-50px); }
  to { opacity: 1; transform: translateX(0px); }
`;

const appearFromRight = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

// Tela externa = DARK only (forçada no App.tsx -> ThemeProvider recebe tema dark).
// Layout: CARD centralizado na viewport (form à esquerda, hero à direita dentro do card).
export const Container = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    padding: 0 88px;
    align-items: center;
    justify-content: center;
    background: ${(props) => props.theme.colors.interfacePure0};

    @media (max-width: 800px) {
        padding: 0 24px;
    }
`;

export const MainWrapper = styled.div`
    display: flex;
    width: 100%;
    max-width: 1180px;
    height: 80%;
    max-height: 600px;
    border-radius: 16px;
    position: relative;
    overflow: hidden;
    border: 1px solid ${(props) => props.theme.colors.interfaceBorder100};
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: absolute;
        top: 0;
        margin-top: -42px;
        width: 100%;
        left: 2px;
        max-width: 98%;
        z-index: 4;
    }

    .back {
        display: flex;
        align-items: center;
        background: transparent;
        border: none;
        color: ${(props) => props.theme.colors.interfaceText300};
        line-height: 10px;
        font-size: 15px;
        cursor: pointer;
        transition: color .2s;
        &:hover { color: ${(props) => props.theme.colors.interfaceText500}; }
        span { margin-right: 8px; }
    }

    .password { label span { font-size: 14px; } }

    @media (max-width: 800px) {
        flex-direction: column;
        height: auto;
        max-height: none;
        .header { flex-direction: column; align-items: center; margin-top: -40px; }
        .back { justify-content: center; }
    }
`;

export const MainLeft = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 4% 5%;
    background: ${(props) => props.theme.colors.white};
    width: 48%;
    border-radius: 16px 0 0 16px;

    /* logo sempre no topo, na mesma altura em todas as views (login e "Esqueci a senha") */
    &.top-align { justify-content: flex-start; }

    h1 {
        color: ${(props) => props.theme.colors.interfaceText500};
        span { color: ${(props) => props.theme.colors.primaryRed400}; }
    }

    .forgot { font-size: 32px; font-weight: 600; margin-bottom: 25px; color: ${(props) => props.theme.colors.interfaceText500}; }
    .forgot-text { font-size: 16px; font-weight: 400; line-height: 24px; max-width: 320px; color: ${(props) => props.theme.colors.interfaceText300}; }

    form {
        display: flex;
        flex-direction: column;
        gap: 15px;
        animation: ${appearFromLeft} 0.7s;

        .password { position: relative; }
        .icon { position: absolute; top: 40%; right: 5%; cursor: pointer; color: ${(props) => props.theme.colors.interfaceText300}; }
        .checkbox { display: flex; align-items: center; }
        .field { display: flex; align-items: center; gap: 1rem; }

        button { width: 248px; }

        .buttons {
            display: flex;
            gap: 15px;
            button {
                &:first-child {
                    width: 160px;
                    background: transparent;
                    border-radius: 8px;
                    border: 1px solid ${(props) => props.theme.colors.primaryRed400};
                    color: ${(props) => props.theme.colors.primaryRed400};
                    transition: all .3s;
                    &:hover { background: ${(props) => props.theme.colors.primaryRed400}; color: ${(props) => props.theme.colors.pureWhite}; }
                }
            }
        }
    }

    .forgot-form { height: auto; }

    .confirm {
        position: relative;
        .check { position: absolute; top: 0; right: 1%; font-size: 14px; font-weight: 500; color: ${(props) => props.theme.colors.interfaceDanger}; display: flex; align-items: center; gap: 5px; }
        .ok { display: flex; gap: 8px; position: absolute; top: 0; right: 1%; font-size: 14px; font-weight: 500; color: ${(props) => props.theme.colors.interfaceSuccess}; }
    }

    .danger input { border: 1px solid ${(props) => props.theme.colors.interfaceDanger300}; }
    .strong input { border: 1px solid ${(props) => props.theme.colors.interfaceSuccess200}; }

    @media (max-width: 800px) {
        width: 100%;
        border-radius: 16px 16px 0 0;
        padding: 32px 24px;
        form button { width: 100%; }
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: fit-content;
    margin-bottom: 24px;
    gap: 13px;
    animation: ${appearFromLeft} 0.7s;

    img { margin-bottom: 8px; }

    p {
        font-size: 18px;
        font-weight: 400;
        color: ${(props) => props.theme.colors.interfaceText300};
        padding-top: 16px;
        .blueTitle { font-weight: 700; font-size: 18px; }
        .redTitle { color: ${(props) => props.theme.colors.primaryRed400}; font-weight: 700; font-size: 18px; }
        .orangeTitle { color: ${(props) => props.theme.colors.primaryRed400}; font-weight: 700; font-size: 18px; }
    }
`;

export const Footer = styled.div`
    margin-top: 16px;
    animation: ${appearFromLeft} 0.7s;

    button {
        display: flex;
        align-items: center;
        gap: 8px;
        background: transparent;
        border: none;
        color: ${(props) => props.theme.colors.interfaceText400};
        text-decoration: underline;
        cursor: pointer;
        &:hover { color: ${(props) => props.theme.colors.interfaceText500}; }
    }
`;

export const MainRight = styled.div`
    position: relative;
    width: 52%;
    height: 100%;
    overflow: hidden;
    border-radius: 0 16px 16px 0;
    background: ${(props) => props.theme.colors.interfacePure100};

    /* hero cobre toda a área, dessaturada e escurecida (filtro EasyJur OS) */
    img {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center 48%;
        /* mesmo tom da imagem do EasyJur OS (app.easyjur.com): grayscale parcial + escurecida */
        filter: grayscale(0.85) brightness(0.7);
        animation: ${appearFromRight} 0.9s;
        background: transparent;
        padding: 0;
    }

    /* gradiente funde a borda esquerda da imagem no card escuro */
    &::after {
        content: '';
        position: absolute;
        inset: 0;
        background: linear-gradient(
            90deg,
            ${(props) => props.theme.colors.white} 0%,
            rgba(31, 31, 31, 0.55) 18%,
            rgba(31, 31, 31, 0.12) 55%,
            rgba(31, 31, 31, 0) 100%
        );
        z-index: 1;
    }

    .text-wrapper {
        position: absolute;
        right: 40px;
        bottom: 40px;
        z-index: 2;
        display: flex;
        flex-direction: column;
        gap: 6px;
        text-align: right;
        max-width: 95%;
        /* sombra garante leitura do texto sobre a foto (contraste) */
        text-shadow: 0 1px 8px rgba(0, 0, 0, 0.85), 0 0 2px rgba(0, 0, 0, 0.6);
    }

    .text-wrapper-title {
        font-size: 34px;
        font-weight: 700;
        line-height: 1.2;
        color: ${(props) => props.theme.colors.pureWhite};
    }

    .text-wrapper-accent {
        color: ${(props) => props.theme.colors.primaryRed400};
    }

    .text-wrapper-subtitle {
        font-size: 16px;
        font-weight: 600;
        color: ${(props) => props.theme.colors.pureWhite};
    }

    @media (max-width: 800px) {
        display: none;
    }
`;
